// src/pages/Home.js
import "../styles/Home.css";
import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import FeaturedWork from "../components/FeaturedWork";
import Footer from "../components/Footer";

// Firestore
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const Home = () => {
  const [intro, setIntro] = useState({
    heading: "Introduction",
    text:
      "Hi, I’m Sulaksha Shetty, but you can call me SuShe!\nI’m a creative freelancer passionate about making digital designs and handmade gifts that are both beautiful and meaningful. Whether you’re a brand, startup, or an individual with an idea, I’d love to help bring it to life with clarity, creativity, and care.",
  });

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const snap = await getDoc(doc(db, "pageContent", "homeIntro"));
        if (mounted && snap.exists()) {
          const d = snap.data() || {};
          setIntro((prev) => ({
            heading: d.heading || prev.heading,
            text: d.text || prev.text,
          }));
        }
      } catch (e) {
        if (process.env.NODE_ENV === "development") {
          console.warn("[Home Intro] Using defaults. Firestore read failed:", e);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div>
      <Hero />

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="section-container">
          <h2 className="intro-heading">{intro.heading}</h2>
          <p className="intro-text">
            {intro.text.split("\n").map((line, idx) => (
              <React.Fragment key={idx}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      </section>

      <FeaturedWork />
      <Footer />
    </div>
  );
};

export default Home;
